import { z } from 'zod/v3';

export const redirectsSchema = z.array(
  z.object({
    source: z.string(),
    destination: z.string(),
  }),
);
export type Redirects = z.infer<typeof redirectsSchema>;

export const redirectsApiResponseSchema = z.object({
  redirects: redirectsSchema,
});
export type RedirectsApiResponse = z.infer<typeof redirectsApiResponseSchema>;
